import { Spinner } from "@/components/ui/spinner";
import { Text } from "@/components/ui/text";
import type { Dictionary } from "../../../../dictionaries";
import { formatAmount } from "../payment.utils";
import { InfoCard, InfoRow, StatusOverlay } from "./status-overlay";

interface WaitingMobileViewProps {
  dictionary: Dictionary;
  onCancel: () => void | Promise<void>;
  /**
   * What the payer is actually being charged - the figure the USSD prompt on
   * their phone asks for. For cross-market payers this is in their own
   * currency, not the merchant's.
   */
  amount?: number | null;
  currency?: string | null;
}

export function WaitingMobileView({
  dictionary,
  onCancel,
  amount,
  currency,
}: WaitingMobileViewProps) {
  const { waiting } = dictionary;
  const chargedText =
    typeof amount === "number" && amount > 0 && currency
      ? formatAmount(amount, currency)
      : null;

  return (
    <StatusOverlay
      icon={<Spinner className="size-10" />}
      title={waiting.mobile.title}
      description={
        <>
          {waiting.mobile.description}
          <br />
          {waiting.mobile.instruction}
        </>
      }
      cancelLabel={waiting.cancel}
      onCancel={onCancel}
    >
      <InfoCard>
        {chargedText && (
          <InfoRow className="flex items-center justify-between gap-6">
            <span className="text-muted-foreground">
              {waiting.mobile.amountLabel}
            </span>
            <Text className="font-semibold tabular-nums">{chargedText}</Text>
          </InfoRow>
        )}
        <InfoRow
          border={!!chargedText}
          className="text-sm text-muted-foreground"
        >
          {waiting.card.warning}
        </InfoRow>
      </InfoCard>
    </StatusOverlay>
  );
}
